import * as THREE from 'three'
import React, { useMemo } from 'react'
import { params } from '../../../../../../redux/reducers/reducer'
import { extrudeSettings } from '../../../../../../utils/Functions'

const GarageDoorFrameoutDoorDegree = ({ width, height, trimWidth, trimColor}) => {

    const trimModel = useMemo(() => {
        let trimOffset;
        if(width >= 2.5){
            trimOffset = 1
        } else {
            trimOffset = width / 3
        }
        const offset = 0.05

        const model = new THREE.Shape();
        model.moveTo(-width / 2,  -height / 2);
        model.lineTo(-width / 2,  height / 2 - trimOffset);
        model.lineTo(-width / 2 + trimOffset,  height / 2 );
        model.lineTo(width / 2 - trimOffset,  height / 2 );
        model.lineTo(width / 2,  height / 2 - trimOffset);
        model.lineTo(width / 2,  -height / 2 );
        model.lineTo(width / 2 - trimWidth,  -height / 2 );
        model.lineTo(width / 2 - trimWidth,  height / 2 - trimOffset - offset);
        model.lineTo(width / 2 - trimOffset - offset,  height / 2 - trimWidth - 0.02);
        model.lineTo(-width / 2 + trimOffset + offset,  height / 2 - trimWidth - 0.02);
        model.lineTo(-width / 2 + trimWidth,  height / 2 - trimOffset - offset);
        model.lineTo(-width / 2 + trimWidth,  -height / 2 );
        model.closePath();    
        
        return model;
    }, [width, height, trimWidth])
    
    const doorModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth,  -height / 2);
        model.lineTo(-width / 2 + trimWidth,  height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth,  height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth,  -height / 2);
        model.closePath();

        return model
    }, [width, height, trimWidth])

    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            <mesh position={[0, 0, 0.05]} visible={false}>
                <extrudeGeometry args={[doorModel, extrudeSettings(0.2)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={'white'} opacityValue={0.01} transparent />
            </mesh>
        </>
    )
}

export default GarageDoorFrameoutDoorDegree